import {AtomContainer, type IAtomModel} from "@alchemiesolns/atomcontainer";
import {v3} from "@alchemiesolns/maths";

export const svgCharge = {
    getChargeLabel: (chargeNum: number) => {
        if (chargeNum === 1) {
            return "+";
        } else if (chargeNum === -1) {
            // Purposefully en-dash not minus for longer length
            return "_";
        } else if (chargeNum > 0) {
            return chargeNum + "+";
        } else if (chargeNum < 0) {
            return Math.abs(chargeNum) + "-";
        } else {
            return ""
        }
    },
    calcChargeCoords: (
        container: AtomContainer,
        chargePositions: number[][],
        chargeRadius: number = 4,
        _visibleAtoms: IAtomModel[] = []
    ) => {
        return container.atoms.filter(a => a.charge !== 0.0)
            .map(a => {
                // Calculate charge offset distance from atom center
                const chargeOffset = chargeRadius * 3.4;

                return {
                    chg: svgCharge.getChargeLabel(a.charge),
                    pos: [a.pos!.x, a.pos!.y, a.pos!.z ?? 0.0],
                    chargeOffset,
                    atom: a
                };
            })
            .map((chg, idx) => {
                if (idx < chargePositions.length) {
                    return ({chg: chg.chg, pos: v3.addVectors(chg.pos, chargePositions[idx])});
                } else {
                    // Match DynamicCharge.tsx calculation: atomPos + dir * chargeOffset
                    // Direction is normalized [1, -1, 0] (upper-right by default)
                    const direction = v3.normalize([1, -1, 0]);
                    const offset = v3.scale(direction, chg.chargeOffset);
                    return ({chg: chg.chg, pos: v3.addVectors(chg.pos, offset)});
                }
            })
    }
}